import React, { useState, useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { db } from "../firebase/config";
import "../styles/myProfile.css";

const TICKET_STATUS_STYLE = {
  Paid:      { background: "#e8f5e9", color: "#2e7d32" },
  Used:      { background: "#e3f2fd", color: "#1565c0" },
  Cancelled: { background: "#fde8e8", color: "#c0392b" },
};

const fmtTicketDate = (ts) => {
  if (!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }) +
    " · " + d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
};

export default function TicketsCard({ userId }) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const canvasRefs = useRef({});

  const downloadTicket = (ticket) => {
    const canvas = canvasRefs.current[ticket.id];
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `ticket-${(ticket.eventName || "event").replace(/\s+/g, "-").toLowerCase()}.png`;
    a.click();
  };

  useEffect(() => {
    if (!userId) return;
    const unsub = db.collection("tickets")
      .where("userId", "==", userId)
      .onSnapshot((snap) => {
        const data = snap.docs
          .map((d) => ({ id: d.id, ...d.data() }))
          .sort((a, b) => (b.createdAt?.toMillis?.() || 0) - (a.createdAt?.toMillis?.() || 0));
        setTickets(data);
        setLoading(false);
      }, (err) => { console.error(err); setLoading(false); });
    return () => unsub();
  }, [userId]);

  return (
    <div className="profile-card profile-card--orders">
      <div className="profile-card__header">
        <h2 className="profile-card__title">My Tickets</h2>
        {!loading && <span className="profile-card__count">{tickets.length} ticket{tickets.length !== 1 ? "s" : ""}</span>}
      </div>

      {loading ? (
        <div className="profile-orders__loading">
          <div className="profile-orders__spinner" />
          <p>Loading tickets…</p>
        </div>
      ) : tickets.length === 0 ? (
        <p className="profile-orders__empty">No tickets yet — browse <a href="/events">Events</a> to buy one.</p>
      ) : (
        <div className="profile-orders__list">
          {tickets.map((t) => (
            <div key={t.id} className="profile-order">
              <div className="profile-order__top">
                <div>
                  <p className="profile-order__id">{t.eventName}</p>
                  <p className="profile-order__date">{fmtTicketDate(t.eventDate)}</p>
                </div>
                <div className="profile-order__right">
                  <span className="profile-order__status" style={TICKET_STATUS_STYLE[t.status] || TICKET_STATUS_STYLE.Paid}>
                    {t.status || "Paid"}
                  </span>
                  <p className="profile-order__total">{t.ticketTypeName}</p>
                </div>
              </div>

              {t.status === "Paid" && (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, padding: "16px 0 4px" }}>
                  <QRCodeCanvas
                    ref={(el) => { canvasRefs.current[t.id] = el; }}
                    value={JSON.stringify({ ticketId: t.id, code: t.code })}
                    size={140}
                  />
                  <button
                    onClick={() => downloadTicket(t)}
                    style={{
                      background: "none", border: "1px solid #ddd", color: "#555",
                      padding: "5px 14px", borderRadius: 16, fontSize: 11,
                      cursor: "pointer", fontFamily: "inherit",
                    }}
                  >
                    ↓ Download
                  </button>
                </div>
              )}
              {t.status === "Used" && (
                <p style={{ fontSize: 11, color: "#888", textAlign: "center", padding: "8px 0" }}>
                  Checked in{t.usedAt ? ` · ${fmtTicketDate(t.usedAt)}` : ""}
                </p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
